/* !
 * setting.js v1.0.0
 * Copyright, Connecty Inc.
 */
(() => {
	const siteName = 'default-package';
	const htmlHasClass = (_class) => { return document.documentElement.classList.contains(_class); };
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			header: {
				desktop: 110,
				sp: 60
			}
		},
		localDecision() {
			const regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.|100\\.64\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() { // ローカル環境ならincludeをAjaxで読み込む
			const _this = this;
			const key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);

			includeClass.forEach(ele => {
				let path = ele.innerHTML.split(' ')[1];
				ajaxArray.push(path);
			});

			if (ajaxArray.length) {
				ajaxArray.forEach(ele => {
					let xhr = new XMLHttpRequest();
					let promise = new Promise((resolve, reject) => {
						xhr.onreadystatechange = function () {
							if (xhr.readyState === 4) {
								if (xhr.status === 200) {
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							}
						};
					});
					xhr.open('GET', ele + '.html', true);
					xhr.send();
					ajaxArrayList.push(promise);
				});

				Promise.all(ajaxArrayList).then(results => {
					let regExp = new RegExp(key);

					results.forEach(ele => {
						let classList = ele.split(/ |\"/g);
						let position;

						classList.forEach(ele2 => {
							if (ele2.match(regExp)) { position = ele2; }
						});
						document.querySelectorAll('.' + position).forEach(ele2 => {
							ele2.outerHTML = ele;
						});
						console.log('Succeeded to read the include file!:', position);
					});

					// 置換完了時にカスタムイベントを発火
					document.dispatchEvent(new Event('localincludeLoaded'));

					_this.loadDelayScript();
				}).catch((error) => {
					console.error('Failed to read the include file:', error);

					document.dispatchEvent(new Event('localincludeLoaded'));
					_this.loadDelayScript();
				});
			} else {
				document.dispatchEvent(new Event('localincludeLoaded'));
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			hashes.forEach(ele => {
				hash = ele.split('=');
				hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			});
			return vars;
		},
		accordion() {
			const details = document.querySelectorAll('.js-accordion');

			details.forEach(ele => {
				const summary = ele.querySelector('summary');
				const wrapper = ele.querySelector('.mod-accordion-wrapper');
				const plus = ele.querySelector('.mod-accordion-plus');
				summary.addEventListener('click', e => {
					e.preventDefault();
					if (ele.open) {
						const close = wrapper.animate(
							{
								opacity: [1, 0],
								height: [wrapper.offsetHeight + 'px', 0],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						plus.animate(
							{ rotate: ['90deg', '0deg'] },
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
						close.onfinish = () => {
							ele.removeAttribute('open');
						}
					} else {
						ele.setAttribute('open', 'true');
						wrapper.animate(
							{
								opacity: [0, 1],
								height: [0, wrapper.offsetHeight + 'px'],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						plus.animate(
							{ rotate: ['0deg', '90deg'] },
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
					}
				});
			});
		},
		accBtn(){
			const accBtns = document.querySelectorAll('.js-accBtn');
			
			accBtns.forEach(btn => {
				btn.addEventListener('click', (e) => {
					e.preventDefault();
					
					// 自身にis-activeクラスをtoggle
					btn.classList.toggle('is-active');
					
					// 自身の次の要素を取得
					const nextElement = btn.nextElementSibling;
					
					if (nextElement) {
						// slideToggle的な動作を実装
						if (nextElement.style.display === 'none' || !nextElement.style.display) {
							// 要素を表示する
							nextElement.style.display = 'block';
							nextElement.style.height = '0px';
							nextElement.style.overflow = 'hidden';
							
							// 実際の高さを取得
							const height = nextElement.scrollHeight;
							
							// アニメーション
							nextElement.animate(
								{
									height: ['0px', height + 'px']
								},
								{
									duration: 300,
									easing: 'ease'
								}
							).onfinish = () => {
								nextElement.style.height = '';
								nextElement.style.overflow = '';
							};
						} else {
							// 要素を非表示にする
							const height = nextElement.offsetHeight;
							nextElement.style.height = height + 'px';
							nextElement.style.overflow = 'hidden';
							
							nextElement.animate(
								{
									height: [height + 'px', '0px']
								},
								{
									duration: 300,
									easing: 'ease'
								}
							).onfinish = () => {
								nextElement.style.display = 'none';
								nextElement.style.height = '';
								nextElement.style.overflow = '';
							};
						}
					}
				});
			});
		},
		carousel() {
			// Splideの4カラムカルーセル設定
			const carouselElements = document.querySelectorAll('.js-carousel');
			
			// Splideインスタンスを保存する配列
			const splideInstances = [];
			
			// カスタムpaginationを再生成する関数
			const recreateCustomPagination = (element, splide, slideCount) => {
				// SP時はpaginationを表示、PC時は5カラム以上でpaginationを表示
				const windowWidth = window.innerWidth || document.documentElement.clientWidth || screen.width || 1024;
				const showPagination = windowWidth <= 1024 ? true : slideCount > 4;
				
				if (showPagination) {
					const paginationContainer = element.querySelector('.splide__pagination');
					if (paginationContainer) {
						// デフォルトのpaginationをクリア
						paginationContainer.innerHTML = '';
						
						// スライド数分のドットを作成
						for (let i = 0; i < slideCount; i++) {
							const dot = document.createElement('button');
							dot.className = 'splide__pagination__page';
							dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
							dot.setAttribute('data-slide', i);
							dot.setAttribute('type', 'button');
							
							if (i === 0) {
								dot.classList.add('is-active');
							}
							
							dot.addEventListener('click', (e) => {
								e.preventDefault();
								const targetIndex = parseInt(e.currentTarget.getAttribute('data-slide'));
								splide.go(targetIndex);
								
								// 全てのドットからactiveクラスを削除
								paginationContainer.querySelectorAll('.splide__pagination__page').forEach(d => {
									d.classList.remove('is-active');
								});
								// クリックされたドットにactiveクラスを追加
								e.currentTarget.classList.add('is-active');
							});
							
							paginationContainer.appendChild(dot);
						}
						
						// スライド移動時のドット状態更新（アニメーション開始時）
						splide.on('move', (newIndex) => {
							paginationContainer.querySelectorAll('.splide__pagination__page').forEach((d, index) => {
								d.classList.toggle('is-active', index === newIndex);
							});
						});
					}
				}
			};
			
			// デバイス幅とカード数に応じてSplide使用判定する関数
			const checkSplideCondition = (slideCount) => {
				let windowWidth = window.innerWidth;
				
				// window.innerWidthが正常に取得できない場合の対処
				if (windowWidth === 0 || !windowWidth) {
					// document.documentElement.clientWidthまたはscreen.widthで代替
					windowWidth = document.documentElement.clientWidth || screen.width || 1024;
				}
				
				// スマホサイズ（768px以下）では2枚以上でカルーセル
				if (windowWidth <= 768) {
					return slideCount >= 2;
				}
				// タブレットサイズ（769px-1024px）では3枚以上でカルーセル
				else if (windowWidth <= 1024) {
					return slideCount >= 3;
				}
				// デスクトップサイズ（1025px以上）では5枚以上でカルーセル
				// （4枚まではリキッドレイアウトで対応）
				else {
					return slideCount >= 5;
				}
			};
			
			// Splideを初期化する関数
			const initializeSplide = (element, slideCount) => {
				// 既存のSplideインスタンスがあれば削除
				const existingInstance = splideInstances.find(instance => instance.element === element);
				if (existingInstance) {
					existingInstance.splide.destroy();
					const index = splideInstances.indexOf(existingInstance);
					splideInstances.splice(index, 1);
				}
				
				// SP時はpaginationを表示、PC時は5カラム以上でpaginationを表示
				const windowWidth = window.innerWidth || document.documentElement.clientWidth || screen.width || 1024;
				const showPagination = windowWidth <= 1024 ? true : slideCount > 4;
				
				const splide = new Splide(element, {
					type: 'loop',
					perPage: 4,
					perMove: 1,
					gap: '56px',
					pagination: showPagination,
					arrows: true,
					breakpoints: {
						1024: {
							perPage: 1,
							fixedWidth: false,
							autoWidth: true,
							gap: '20px',
							autoCenter: false,
							trimSpace: false,
						}
					},
					classes: {
						arrows: 'splide__arrows carousel-arrows',
						arrow: 'splide__arrow carousel-arrow',
						prev: 'splide__arrow--prev carousel-arrow--prev',
						next: 'splide__arrow--next carousel-arrow--next',
					}
				});
				
				splide.mount();
				
				// インスタンスを保存
				splideInstances.push({ element, splide, slideCount });
				
				return splide;
			};
			
			carouselElements.forEach(element => {
				const slides = element.querySelectorAll('.splide__slide');
				const slideCount = slides.length;
				
				// デバイス幅とカード数に応じてSplide使用判定
				const shouldUseSplide = checkSplideCondition(slideCount);
				
				if (!shouldUseSplide) {
					element.classList.add('carousel-static');
					element.classList.remove('carousel-splide');
					return; // Splideを初期化しない
				}
				
				// 条件を満たす場合のみSplideを初期化
				element.classList.add('carousel-splide');
				element.classList.remove('carousel-static');
				
				const splide = initializeSplide(element, slideCount);
				
				// カスタムpagination作成（スライド数分のドット）
				recreateCustomPagination(element, splide, slideCount);
			});

			// ウィンドウリサイズ時の処理
			let carouselResizeTimeout;
			window.addEventListener('resize', () => {
				clearTimeout(carouselResizeTimeout);
				carouselResizeTimeout = setTimeout(() => {
					// 既存のSplideインスタンスを全て破棄
					splideInstances.forEach(({ splide }) => {
						splide.destroy();
					});
					splideInstances.length = 0;
					
					// 全てのカルーセル要素を再評価
					carouselElements.forEach(element => {
						const slides = element.querySelectorAll('.splide__slide');
						const slideCount = slides.length;
						
						// デバイス幅とカード数に応じてSplide使用判定
						const shouldUseSplide = checkSplideCondition(slideCount);
						
						if (!shouldUseSplide) {
							element.classList.add('carousel-static');
							element.classList.remove('carousel-splide');
							return; // Splideを初期化しない
						}
						
						// 条件を満たす場合のみSplideを初期化
						element.classList.add('carousel-splide');
						element.classList.remove('carousel-static');
						
						const splide = initializeSplide(element, slideCount);
						if (splide) {
							// カスタムpaginationを再生成
							recreateCustomPagination(element, splide, slideCount);
						}
					});
				}, 300);
			});
			
			// 初期化後の再チェック（タイミング問題対応）
			setTimeout(() => {
				carouselElements.forEach(element => {
					const slides = element.querySelectorAll('.splide__slide');
					const slideCount = slides.length;
					const currentShouldUseSplide = checkSplideCondition(slideCount);
					const isCurrentlyStatic = element.classList.contains('carousel-static');
					const isCurrentlySplide = element.classList.contains('carousel-splide');
					
					// 判定が変わった場合は再初期化
					if ((currentShouldUseSplide && isCurrentlyStatic) || (!currentShouldUseSplide && isCurrentlySplide)) {
						// 既存のSplideインスタンスがあれば削除
						const existingInstance = splideInstances.find(instance => instance.element === element);
						if (existingInstance) {
							existingInstance.splide.destroy();
							const index = splideInstances.indexOf(existingInstance);
							splideInstances.splice(index, 1);
						}
						
						if (currentShouldUseSplide) {
							// Splideを初期化
							element.classList.add('carousel-splide');
							element.classList.remove('carousel-static');
							
							const splide = initializeSplide(element, slideCount);
							if (splide) {
								recreateCustomPagination(element, splide, slideCount);
							}
						} else {
							// 通常のHTML表示
							element.classList.add('carousel-static');
							element.classList.remove('carousel-splide');
						}
					}
				});
			}, 100);
		},
		mainVisSwiper() {
			// .mod-mainVis要素の存在チェック
			const mainVisElement = document.querySelector('.mod-mainVis.splide');
			if (!mainVisElement) {
				return; // 要素が存在しない場合は処理を終了
			}

			const splide = new Splide('.mod-mainVis.splide', {
				type: 'loop',
				perPage: 1,
				autoplay: true,
				interval: 5000,
				speed: 500,
				arrows: false,
				pagination: true,
				paginationKeyboard: true,
			}).mount();

			// ストップボタンの動的生成
			const checkAndAddStopButton2 = () => {
				const slides = document.querySelectorAll('.mod-mainVis .splide__slide');
				if (slides.length > 1) {
					const track = document.querySelector('.mod-mainVis .splide__track');
					if (track) {
						const stopButton = `
							<button type="button" class="mod-stopBtn splide__toggle" aria-label="自動再生制御" style="position: absolute; width: 0; height: 0; opacity: 0; overflow: hidden;">
								<span class="splide__toggle__play">
									<svg aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#mvplay"></use></svg>
								</span>
								<span class="splide__toggle__pause">
									<svg aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#mvstop"></use></svg>
								</span>
							</button>
						`;
						track.insertAdjacentHTML('afterend', stopButton);
					}
					// コントローラーをdivで囲う
					setTimeout(() => {
						const stopBtn = document.querySelector('.mod-mainVis .mod-stopBtn');
						const pagination = document.querySelector('.mod-mainVis .splide__pagination');
						if (stopBtn && pagination) {
							const controlWrapper = document.createElement('div');
							controlWrapper.className = 'mod-mainVis-controls';
							pagination.parentNode.insertBefore(controlWrapper, pagination);
							controlWrapper.appendChild(pagination);
							controlWrapper.appendChild(stopBtn);
							
							// レイアウトシフトを防ぐためのインラインスタイルを削除
							stopBtn.removeAttribute('style');
							
							// ストップボタンのクリックイベントを追加
							stopBtn.addEventListener('click', () => {
								const autoplayComponent = splide.Components.Autoplay;
								if (stopBtn.classList.contains('is-paused')) {
									// 再生開始
									autoplayComponent.play();
									stopBtn.classList.remove('is-paused');
								} else {
									// 停止
									autoplayComponent.pause();
									stopBtn.classList.add('is-paused');
								}
							});
							
							// 初期状態を設定（自動再生中なので停止ボタンを表示）
							stopBtn.classList.remove('is-paused');
						}
					}, 100);
				}
			};

			checkAndAddStopButton2();
		},
		dateFormat(){ //営業時間整形
			// js-dateFormatクラスを持つ要素を取得
			const dateElements = document.querySelectorAll('.js-dateFormat');
			
			dateElements.forEach(element => {
				// 元のテキスト内容を取得（例: "0700-0000"）
				let timeText = element.textContent.trim();
				
				// 時間フォーマットのパターンをチェック（HHMM-HHMM形式）
				const timePattern = /^(\d{4})-(\d{4})$/;
				const match = timeText.match(timePattern);
				
				if (match) {
					const startTime = match[1]; // "0700"
					const endTime = match[2];   // "0000"
					
					// 時間を HH:MM 形式に変換する関数
					const formatTime = (time, isEndTime = false) => {
						if (time.length === 4) {
							const hours = time.substring(0, 2);
							const minutes = time.substring(2, 4);
							// 終了時刻で0000の場合のみ24:00として表示
							if (isEndTime && time === '0000') {
								return '24:00';
							}
							return `${hours}:${minutes}`;
						}
						return time;
					};
					
					// フォーマット後の時間文字列を作成
					const formattedStartTime = formatTime(startTime, false);
					const formattedEndTime = formatTime(endTime, true);
					const formattedTimeText = `${formattedStartTime}-${formattedEndTime}`;
					
					// 要素のテキストを更新
					element.textContent = formattedTimeText;
					
					// vis_hideクラスを削除して表示
					element.classList.remove('vis_hide');
				}
			});
		},
		formatKeyword() {
			// サービスラベルの表示制御を先に実行
			const serviceLabelElement = document.querySelector('.serviceLabel');
			
			if (serviceLabelElement) {
				// .label以外のspan要素を取得
				const serviceSpans = serviceLabelElement.querySelectorAll('span:not(.label)');
				
				// いずれかのspan要素に中身があるかチェック
				let hasContent = false;
				serviceSpans.forEach(span => {
					// textContentが空でない、または要素が非表示でない場合
					const text = span.textContent.trim();
					const isVisible = !span.classList.contains('vis_hide') && 
									  window.getComputedStyle(span).display !== 'none';
					
					if (text && text !== '' && isVisible) {
						hasContent = true;
					}
				});
				
				// 中身があるspan要素が一つでもあれば、di_noneクラスを削除
				if (hasContent) {
					serviceLabelElement.classList.remove('di_none');
				}
			}

			// .js_keywordクラスを持つ要素を取得してフォーマット
			const keywordElements = document.querySelectorAll('.js_keyword');
			
			keywordElements.forEach(element => {
				// 元のテキスト内容を取得
				let keywordText = element.textContent.trim();
				
				// "キーワード："の部分を分離
				const keywordPrefix = 'キーワード：';
				if (keywordText.startsWith(keywordPrefix)) {
					const keywords = keywordText.substring(keywordPrefix.length);
					
					// スペース区切りをカンマ区切りに変換
					const formattedKeywords = keywords.split(/[\s　]+/).filter(keyword => keyword.length > 0).join(' ,');
					
					// フォーマット後のテキストを設定
					element.textContent = keywordPrefix + formattedKeywords;
				}
				
				// vis_hideクラスを削除して表示
				element.classList.remove('vis_hide');
			});

			// .js-resultHead要素のvis_hideクラスも削除
			const resultHeadElement = document.querySelector('.js-resultHead');
			if (resultHeadElement) {
				resultHeadElement.classList.remove('vis_hide');
			}
		},
		createSelect() {
			// .js_shopSearchが存在しない場合は処理をスキップ
			if (!document.querySelector('.js_shopSearch')) {
				return;
			}

			// 県コードマッピング（県コード.txtの内容）
			const prefectureCodeMap = {
				'北海道': '01',
				'青森県': '02',
				'岩手県': '03',
				'宮城県': '04',
				'秋田県': '05',
				'山形県': '06',
				'福島県': '07',
				'茨城県': '08',
				'栃木県': '09',
				'群馬県': '10',
				'埼玉県': '11',
				'千葉県': '12',
				'東京都': '13',
				'神奈川県': '14',
				'新潟県': '15',
				'富山県': '16',
				'石川県': '17',
				'福井県': '18',
				'山梨県': '19',
				'長野県': '20',
				'岐阜県': '21',
				'静岡県': '22',
				'愛知県': '23',
				'三重県': '24',
				'滋賀県': '25',
				'京都府': '26',
				'大阪府': '27',
				'兵庫県': '28',
				'奈良県': '29',
				'和歌山県': '30',
				'鳥取県': '31',
				'島根県': '32',
				'岡山県': '33',
				'広島県': '34',
				'山口県': '35',
				'徳島県': '36',
				'香川県': '37',
				'愛媛県': '38',
				'高知県': '39',
				'福岡県': '40',
				'佐賀県': '41',
				'長崎県': '42',
				'熊本県': '43',
				'大分県': '44',
				'宮崎県': '45',
				'鹿児島県': '46',
				'沖縄県': '47'
			};

			const select01 = document.getElementById('select_01');
			const select02 = document.getElementById('select_02');
			const select03 = document.getElementById('select_03');

			// 初期化（セレクトボックスをクリア）
			const resetSelect = (selectElement, defaultText) => {
				selectElement.innerHTML = `<option value="default">${defaultText}</option>`;
			};

			// 都道府県データを取得してselect_01に設定
			const loadPrefectures = async () => {
				try {
					const response = await fetch('/ajax/prefectures.json');
					const data = await response.json();
					
					// デフォルトオプションをクリア
					select01.innerHTML = '<option value="default">都道府県</option>';
					
					// 都道府県オプションを追加
					data.rt_bn_prefectures_list.forEach(prefecture => {
						const option = document.createElement('option');
						const prefName = prefecture.cf_s_tenpo_jusho_1;
						const prefCode = prefectureCodeMap[prefName];
						option.value = prefCode;
						option.textContent = prefName;
						select01.appendChild(option);
					});

					// カスタムセレクトのオプションリストを更新
					this.updateCustomSelectDisplay(select01);
				} catch (error) {
					console.error('都道府県データの取得に失敗しました:', error);
				}
			};

		// 市区名データを取得してselect_02に設定
		const loadMunicipalities = async (prefectureCode) => {
			try {
				const response = await fetch(`/ajax/municipalities.json?p_municipalities=${prefectureCode}`);
				const data = await response.json();
				
				// デフォルトオプションをクリア
				resetSelect(select02, '市区名');
				resetSelect(select03, '店舗名');
				
				// 市区名オプションを追加
				data.rt_bn_municipalities_list.forEach(municipality => {
					const option = document.createElement('option');
					option.value = municipality.cf_s_administrative_code;
					option.textContent = municipality.cf_s_tenpo_jusho_2;
					select02.appendChild(option);
				});

				// select_02のis-disabledクラスを削除
				const select02Wrapper = select02.closest('.js-tagSelect');
				if (select02Wrapper) {
					select02Wrapper.classList.remove('is-disabled');
				}


			// カスタムセレクトの表示を更新
			this.updateCustomSelectDisplay(select02);
		} catch (error) {
			console.error('市区名データの取得に失敗しました:', error);
		}
	};

	// 店舗データを取得してselect_03に設定
	const loadStores = async (administrativeCode) => {
		try {
			const response = await fetch(`/ajax/store.json?p_administrative_code=${administrativeCode}`);
			const data = await response.json();
			
			// デフォルトオプションをクリア
			resetSelect(select03, '店舗名');
			
			// 店舗名オプションを追加
			data.rt_bn_store_list.forEach(store => {
				const option = document.createElement('option');
				option.value = store._key;
				option.textContent = store.cf_s_tenpo_nm_kanji;
				select03.appendChild(option);
			});

			// select_03のis-disabledクラスを削除
			const select03Wrapper = select03.closest('.js-tagSelect');
			if (select03Wrapper) {
				select03Wrapper.classList.remove('is-disabled');
			}

			// カスタムセレクトの表示を更新
			this.updateCustomSelectDisplay(select03);
		} catch (error) {
			console.error('店舗データの取得に失敗しました:', error);
		}
	};			// カスタムセレクトの表示を更新する関数
			this.updateCustomSelectDisplay = (selectElement) => {
				const wrapper = selectElement.closest('.js-tagSelect, .js-select');
				if (wrapper) {
					const displayElement = wrapper.querySelector('.custom-select-text');
					if (displayElement) {
						const selectedOption = selectElement.options[selectElement.selectedIndex];
						displayElement.textContent = selectedOption ? selectedOption.textContent : selectElement.options[0].textContent;
					}
					
					// カスタムセレクトのオプションリストを再構築
					if (wrapper.rebuildCustomOptions) {
						wrapper.rebuildCustomOptions();
					}
				}
			};

		// イベントリスナーを設定
		select01.addEventListener('change', (e) => {
			const selectedPrefectureCode = e.target.value;
			if (selectedPrefectureCode !== 'default') {
				loadMunicipalities(selectedPrefectureCode);
				// 都道府県変更時は店舗名もリセット
				resetSelect(select03, '店舗名');
				const select03Wrapper = select03.closest('.js-tagSelect');
				if (select03Wrapper) {
					select03Wrapper.classList.add('is-disabled');
				}
				this.updateCustomSelectDisplay(select03);
			} else {
				resetSelect(select02, '市区名');
				resetSelect(select03, '店舗名');
				const select02Wrapper = select02.closest('.js-tagSelect');
				const select03Wrapper = select03.closest('.js-tagSelect');
				if (select02Wrapper) {
					select02Wrapper.classList.add('is-disabled');
				}
				if (select03Wrapper) {
					select03Wrapper.classList.add('is-disabled');
				}
				this.updateCustomSelectDisplay(select02);
				this.updateCustomSelectDisplay(select03);
			}
		});

		select02.addEventListener('change', (e) => {
			const selectedAdministrativeCode = e.target.value;
			if (selectedAdministrativeCode !== 'default') {
				loadStores(selectedAdministrativeCode);
			} else {
				resetSelect(select03, '店舗名');
				const select03Wrapper = select03.closest('.js-tagSelect');
				if (select03Wrapper) {
					select03Wrapper.classList.add('is-disabled');
				}
				this.updateCustomSelectDisplay(select03);
			}
		});			// カスタムセレクトボックスの初期化（データ読み込み前に実行）
			this.customSelect();

			// 初期データの読み込み
			loadPrefectures();

			// 特定のselectタグに対してカスタムセレクトを再初期化する関数
			this.reinitializeCustomSelect = (selectElement) => {
				const wrapper = selectElement.closest('.js-tagSelect, .js-select');
				if (wrapper) {
					// 既存のカスタムセレクト要素を削除
					const existingDropdown = wrapper.querySelector('.custom-select-dropdown');
					if (existingDropdown) {
						existingDropdown.remove();
					}
					
					// カスタムセレクトを再構築
					this.customSelect();
				}
			};
		},
		shopSearch() {
			// .js_shopSearchが存在しない場合は処理をスキップ
			if (!document.querySelector('.js_shopSearch')) {
				return;
			}

			const shopSearchForm = document.querySelector('.js_shopSearch');
			const keywordInput = document.getElementById('input_01');
			const select01 = document.getElementById('select_01'); // 都道府県
			const select02 = document.getElementById('select_02'); // 市区名
			const select03 = document.getElementById('select_03'); // 店舗名

			// チェックボックスの要素を取得
			const tabakoCheckbox = document.getElementById('check_1'); // タバコ
			const sakeCheckbox = document.getElementById('check_2'); // 酒
			const atmCheckbox = document.getElementById('check_3'); // ATM
			const chushajoCheckbox = document.getElementById('check_4'); // 駐車場
			const selfCheckoutCheckbox = document.getElementById('check_5'); // セルフレジ

			// フォーム送信イベントを処理
			shopSearchForm.addEventListener('submit', (e) => {
				e.preventDefault();

				// URLパラメータを構築
				const params = new URLSearchParams();

				// キーワード検索
				const keywords = keywordInput.value.trim();
				if (keywords) {
					// デリミタ（半角または全角空白）で分割
					const keywordList = keywords.split(/[\s　]+/);
					const keywordString = keywordList.join(' ').trim();
					
					if (keywordString) {
						params.append('p_keywords', keywordString);
						params.append('p_keywords_extras', keywordString);
					}
				}

				// 地域で探す
				if (select01.value !== 'default') {
					// 都道府県名を取得
					const selectedPrefOption = select01.options[select01.selectedIndex];
					params.append('p_prefectures', selectedPrefOption.textContent);
				}

				if (select02.value !== 'default') {
					// 市区名を取得
					const selectedMuniOption = select02.options[select02.selectedIndex];
					params.append('p_municipalities', selectedMuniOption.textContent);
				}

				if (select03.value !== 'default') {
					// 店舗名を取得
					const selectedStoreOption = select03.options[select03.selectedIndex];
					params.append('p_shop', selectedStoreOption.textContent);
				}

				// サービスで探す（チェックされている場合は「○」を設定）
				const whiteCircle = '\u25CB'; // Unicode文字「○」（文字コード0xE2 97 8B）

				if (tabakoCheckbox && tabakoCheckbox.checked) {
					params.append('p_tabako', whiteCircle);
				}

				if (sakeCheckbox && sakeCheckbox.checked) {
					params.append('p_sake', whiteCircle);
				}

				if (atmCheckbox && atmCheckbox.checked) {
					params.append('p_atm', whiteCircle);
				}

				if (chushajoCheckbox && chushajoCheckbox.checked) {
					params.append('p_chushajo', whiteCircle);
				}

				if (selfCheckoutCheckbox && selfCheckoutCheckbox.checked) {
					params.append('p_self_checkout', whiteCircle);
				}

				// 検索結果ページに遷移
				const searchUrl = '/shop/index.html' + (params.toString() ? '?' + params.toString() : '');
				window.location.href = searchUrl;
			});

			// 検索ボタンのクリックイベント（フォーム内のボタン）
			const searchButtons = shopSearchForm.querySelectorAll('button[type="submit"]');
			searchButtons.forEach(button => {
				button.addEventListener('click', (e) => {
					// フォームのsubmitイベントで処理されるため、ここでは特に何もしない
				});
			});

			// URLパラメータから検索状態を復元
			const restoreSearchState = async () => {
				const urlParams = new URLSearchParams(window.location.search);
				
				// キーワードを復元
				const keywords = urlParams.get('p_keywords');
				if (keywords && keywordInput) {
					keywordInput.value = keywords;
				}

				// サービスのチェックボックスを復元
				const whiteCircle = '\u25CB';
				if (urlParams.get('p_tabako') === whiteCircle && tabakoCheckbox) {
					tabakoCheckbox.checked = true;
				}
				if (urlParams.get('p_sake') === whiteCircle && sakeCheckbox) {
					sakeCheckbox.checked = true;
				}
				if (urlParams.get('p_atm') === whiteCircle && atmCheckbox) {
					atmCheckbox.checked = true;
				}
				if (urlParams.get('p_chushajo') === whiteCircle && chushajoCheckbox) {
					chushajoCheckbox.checked = true;
				}
				if (urlParams.get('p_self_checkout') === whiteCircle && selfCheckoutCheckbox) {
					selfCheckoutCheckbox.checked = true;
				}

				// 地域の選択を復元
				const prefectures = urlParams.get('p_prefectures');
				const municipalities = urlParams.get('p_municipalities');
				const shop = urlParams.get('p_shop');

				if (prefectures) {
					try {
						// 県コードマッピング
						const prefectureCodeMap = {
							'北海道': '01', '青森県': '02', '岩手県': '03', '宮城県': '04', '秋田県': '05',
							'山形県': '06', '福島県': '07', '茨城県': '08', '栃木県': '09', '群馬県': '10',
							'埼玉県': '11', '千葉県': '12', '東京都': '13', '神奈川県': '14', '新潟県': '15',
							'富山県': '16', '石川県': '17', '福井県': '18', '山梨県': '19', '長野県': '20',
							'岐阜県': '21', '静岡県': '22', '愛知県': '23', '三重県': '24', '滋賀県': '25',
							'京都府': '26', '大阪府': '27', '兵庫県': '28', '奈良県': '29', '和歌山県': '30',
							'鳥取県': '31', '島根県': '32', '岡山県': '33', '広島県': '34', '山口県': '35',
							'徳島県': '36', '香川県': '37', '愛媛県': '38', '高知県': '39', '福岡県': '40',
							'佐賀県': '41', '長崎県': '42', '熊本県': '43', '大分県': '44', '宮崎県': '45',
							'鹿児島県': '46', '沖縄県': '47'
						};
						
						const resetSelect = (selectElement, defaultText) => {
							selectElement.innerHTML = `<option value="default">${defaultText}</option>`;
						};
						
						const prefectureCode = prefectureCodeMap[prefectures];
						if (prefectureCode) {
							select01.value = prefectureCode;
							this.updateCustomSelectDisplay(select01);

							// 都道府県が選択された場合は必ず市区名データを読み込む
							const municipalitiesResponse = await fetch(`/ajax/municipalities.json?p_municipalities=${prefectureCode}`);
							const municipalitiesData = await municipalitiesResponse.json();
							
							resetSelect(select02, '市区名');
							resetSelect(select03, '店舗名');
							
							let selectedAdministrativeCode = null;
							municipalitiesData.rt_bn_municipalities_list.forEach(municipality => {
								const option = document.createElement('option');
								option.value = municipality.cf_s_administrative_code;
								option.textContent = municipality.cf_s_tenpo_jusho_2;
								select02.appendChild(option);
								
								// 市区名パラメータがある場合は選択状態にする
								if (municipalities && municipality.cf_s_tenpo_jusho_2 === municipalities) {
									selectedAdministrativeCode = municipality.cf_s_administrative_code;
									select02.value = selectedAdministrativeCode;
								}
						});
						
						// select_02のis-disabledクラスを削除
						const select02Wrapper = select02.closest('.js-tagSelect');
						if (select02Wrapper) {
							select02Wrapper.classList.remove('is-disabled');
						}
						
						this.updateCustomSelectDisplay(select02);							// 市区名が選択された場合（パラメータまたは選択状態）は店舗データを読み込む
							if (selectedAdministrativeCode) {
								const storeResponse = await fetch(`/ajax/store.json?p_administrative_code=${selectedAdministrativeCode}`);
								const storeData = await storeResponse.json();
								
								resetSelect(select03, '店舗名');
								
								storeData.rt_bn_store_list.forEach(store => {
									const option = document.createElement('option');
									option.value = store._key;
									option.textContent = store.cf_s_tenpo_nm_kanji;
									select03.appendChild(option);
									
									// 店舗名パラメータがある場合は選択状態にする
									if (shop && store.cf_s_tenpo_nm_kanji === shop) {
										select03.value = store._key;
									}
								});
								
								// select_03のis-disabledクラスを削除
								const select03Wrapper = select03.closest('.js-tagSelect');
								if (select03Wrapper) {
									select03Wrapper.classList.remove('is-disabled');
								}
								
								this.updateCustomSelectDisplay(select03);
							}
						}
					} catch (error) {
						console.error('地域復元処理でエラー:', error);
					}
				}
			};

			// 初期化完了後に復元処理を実行
			setTimeout(async () => {
				await restoreSearchState();
			}, 1000);

		// 条件クリアボタンの処理
		const cancelButton = shopSearchForm.querySelector('.js-cancel');
		if (cancelButton) {
			cancelButton.addEventListener('click', (e) => {
				e.preventDefault();
				
				// 入力値をクリア
				if (keywordInput) keywordInput.value = '';
				
				// チェックボックスをクリア
				[tabakoCheckbox, sakeCheckbox, atmCheckbox, chushajoCheckbox, selfCheckoutCheckbox].forEach(checkbox => {
					if (checkbox) checkbox.checked = false;
				});
				
				// セレクトボックスをリセット
				const resetSelect = (selectElement, defaultText) => {
					selectElement.innerHTML = `<option value="default">${defaultText}</option>`;
				};
				
				select01.value = 'default';
				resetSelect(select02, '市区名');
				resetSelect(select03, '店舗名');
				
				// is-disabledクラスを追加
				const select02Wrapper = select02.closest('.js-tagSelect');
				const select03Wrapper = select03.closest('.js-tagSelect');
				if (select02Wrapper) {
					select02Wrapper.classList.add('is-disabled');
				}
				if (select03Wrapper) {
					select03Wrapper.classList.add('is-disabled');
				}
				
				// カスタムセレクトの表示を更新
				this.updateCustomSelectDisplay(select01);
				this.updateCustomSelectDisplay(select02);
				this.updateCustomSelectDisplay(select03);
			});
		}			},
		mapCreate() {
			// .js-mapが存在しない場合は処理をスキップ
			const mapElement = document.querySelector('.js-map');
			if (!mapElement) return;

			// 地図中心位置の緯度・経度を取得
			const latElement = document.querySelector('.rt_cf_s_tenpo_zahyo_hokui');
			const lngElement = document.querySelector('.rt_cf_s_tenpo_zahyo_tokei');

			if (!latElement || !lngElement) return;

			const latitude = parseFloat(latElement.textContent.trim());
			const longitude = parseFloat(lngElement.textContent.trim());

			// ピン位置の緯度・経度を取得（オプション）
			const pinLatElement = document.querySelector('.rt_cf_s_tenpo_pin_hokui');
			const pinLngElement = document.querySelector('.rt_cf_s_tenpo_pin_tokei');

			// ピン位置（専用要素があればそれを使用、なければ地図中心と同じ）
			const pinLatitude = pinLatElement ? parseFloat(pinLatElement.textContent.trim()) : latitude;
			const pinLongitude = pinLngElement ? parseFloat(pinLngElement.textContent.trim()) : longitude;

			// 数値妥当性チェック
			if (isNaN(latitude) || isNaN(longitude) || isNaN(pinLatitude) || isNaN(pinLongitude)) return;

			// 緯度・経度の範囲チェック
			if (latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180) return;
			if (pinLatitude < -90 || pinLatitude > 90 || pinLongitude < -180 || pinLongitude > 180) return;

			// Google Maps Embed URLを構築（シンプルで確実な方法）
			const embedUrl = `https://maps.google.com/maps?q=${pinLatitude},${pinLongitude}&t=&z=15&ie=UTF8&iwloc=&output=embed`;

			// iframeのsrc属性を更新
			mapElement.src = embedUrl;
		},
		tabSwitch() {
			let $tab = document.querySelectorAll('.js-tab');
			let $content = document.querySelectorAll('.js-tab-content');
			if ($tab.length) {
				// ハッシュタグで絞り込み
				if (location.hash) {
					let hash = location.hash.split('#')[1];
					$tab.forEach(ele => {
						ele.classList.remove(a);
						if (ele.getAttribute('data-target').match(hash)) {
							ele.classList.remove(a);
						}
					});
					$content.forEach(ele => {
						ele.classList.remove(a);
						ele.classList.remove(v);
						if (ele.getAttribute('data-target').match(hash)) {
							$(ele).addClass(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						}
					});
				}

				$tab.forEach(ele => {
					ele.addEventListener('click', () => {
						$tab.forEach(ele2 => { ele2.classList.remove(a); })
						ele.classList.add(a);
						$content.forEach(ele => {
							ele.classList.remove(a);
							ele.classList.remove(v);
						});

						let $target;
						let target = ele.getAttribute('data-target');
						if (target === 'all') {
							$target = $content;
						} else {
							$target = document.querySelectorAll('[data-target="' + target + '"]');
						}
						$target.forEach(ele => {
							ele.classList.add(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						});
					});
				});
			}
		},
		easeScroll() {
			const scrollToObject = (_self) => {
				let hash = _self.currentTarget.href.split('#')[1];
				let pos = hash === 'pagetop' ? 0 : document.getElementById(hash).getBoundingClientRect().top;
				let offset = hash === 'pagetop' ? 0 : window.scrollY;
				pos += offset;

				if (hash !== 'pagetop') {
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos = pos - FUNCTIONS.va.header.sp;
					} else {
						pos = pos - FUNCTIONS.va.header.desktop;
					}
				}
				window.scrollTo({ top: pos, behavior: 'smooth' });
			}
			// フォーカス用関数
			const scrollFocus = (_hash) => {
				let hash = _hash;
				if (hash !== 'pagetop') {
					const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
					const focusableElements = Array.from(
						document.getElementById(hash).querySelectorAll(focusableElementsSelector)
					);
					if(focusableElements.length) {
						focusableElements[0].focus({ preventScroll: true });
					}
				}
			};
			// スクロール完了後に実行する関数
			let scrollResolveTimeout;
			const waitForScrollComplete = (_hash) => {
			  return new Promise((resolve) => {
				const scrollTimeout = setTimeout(() => {
				  resolve(true);
				}, 100);
				const scrollTimeoutEvent = addEventListener('scroll', function fn (e) {
					clearTimeout(scrollTimeout);
					clearTimeout(scrollResolveTimeout);
					scrollResolveTimeout = setTimeout(function () {
						scrollFocus(_hash);
						removeEventListener('scroll', fn);
						resolve(true);
					}, 100);
				});
			  });
			};
			document.querySelectorAll('a[rel="scroll"]').forEach((ele) => {
				ele.addEventListener('click', async (e) => {
					e.preventDefault();
					if (/#/.test(e.currentTarget.href)) {
						scrollToObject(e);
						let hash = e.currentTarget.href.split('#')[1];
						await waitForScrollComplete(hash);
						return false;
					}
				});
			});
		},
		easeScrollHash() {
			const hash = location.hash;
			if (hash) {
				// フォーカス用関数
				const scrollFocus = (_hash) => {
					let hash = _hash;
					if (hash !== 'pagetop') {
						const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
						const focusableElements = Array.from(
							document.getElementById(hash).querySelectorAll(focusableElementsSelector)
						);
						if(focusableElements.length) {
							focusableElements[0].focus();
						}
					}
				}
				// スクロール完了後に実行する関数
				let scrollResolveTimeout;
				const waitForScrollComplete = (_hash) => {
					return new Promise((resolve) => {
						const scrollTimeout = setTimeout(() => {
						resolve(true);
						}, 100);
						const scrollTimeoutEvent = addEventListener('scroll', function fn (e) {
							clearTimeout(scrollTimeout);
							clearTimeout(scrollResolveTimeout);
							scrollResolveTimeout = setTimeout(function () {
								scrollFocus(_hash);
								removeEventListener('scroll', fn);
								resolve(true);
							}, 100);
						});
					});
				}
				window.addEventListener('load', async () => {
					document.documentElement.style.display = 'none';
					document.body.style.display = 'none';

					setTimeout(() => {
						document.documentElement.style.display = 'block';
						document.body.style.display = 'block';

						let pos = document.getElementById(hash.split('#')[1]).getBoundingClientRect().top;

						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							pos -= FUNCTIONS.va.header.sp;
						} else {
							pos -= FUNCTIONS.va.header.desktop;
						}
						window.scrollTo({ top: pos, behavior: 'smooth' });
					}, 100);
					await waitForScrollComplete(hash);
				});
			}
		},
		pageTop() {
			let footer = document.querySelector('.footer');
			let $pagetop = document.querySelector('.footer-pagetop');

			if ($pagetop) {
				window.addEventListener('scroll', (e) => {
					if (window.scrollY > '100') {
						$pagetop.classList.add(v);
					} else {
						$pagetop.classList.remove(v);
					}
				});
			}
		},
		setModal() {
			const createModal = (_appendHTML,_target) => {
				const $container = document.createElement('div');
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild($container);

				$container.classList.add(a);
				setTimeout(() => {
					$container.classList.add(v);
					document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
						ele.addEventListener('click', (e) => {
							$container.classList.remove(v);
							setTimeout(() => {
								$container.classList.remove(a);
								$container.remove();
								_target.focus();
							}, 400);
						});
					});
					window.addEventListener("keydown", function (event) {
						if(document.querySelectorAll('.mod-modal-overlay').length) {
							// タブキーが押された時
							if (event.key === "Tab") {
								event.preventDefault();
								// モーダル要素内のフォーカス可能な要素の一覧を取得
								const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
								const focusableElements = Array.from(
								document.querySelector('.mod-modal-overlay').querySelectorAll(focusableElementsSelector)
								);
								// 現在のフォーカス位置を取得
								const focusedItemIndex = focusableElements.indexOf(document.activeElement);
								// shiftキーと同時に押されてた場合
								if (event.shiftKey) {
								if (focusedItemIndex === 0) {
									// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
									focusableElements[focusableElements.length - 1].focus();
								} else {
									// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
									focusableElements[focusedItemIndex - 1].focus();
								}
								} else {
								if (focusedItemIndex === focusableElements.length - 1) {
									// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
									focusableElements[0].focus();
								} else {
									// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
									focusableElements[focusedItemIndex + 1].focus();
								}
								}
							}
							// ESCキーが押された時
							if (event.key === "Escape") {
								event.preventDefault();
								$container.classList.remove(v);
								setTimeout(() => {
									$container.classList.remove(a);
									$container.remove();
									_target.focus();
								}, 400);
							}
						}
					});
				});
			};
			document.querySelectorAll('.mod-modal').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let targetKey = e.currentTarget.getAttribute('data-target');
					let $content = document.querySelector(`.mod-modalContent[data-target="${targetKey}"]`);
					if ($content) {
						let closeButton = document.createElement('button');
						closeButton.setAttribute('type', 'button');
						closeButton.className = 'mod-modal-closeBtn';
						closeButton.setAttribute('aria-label', 'close');
						closeButton.innerHTML = '<span aria-hidden="true"></span>';

						$content.appendChild(closeButton);

						let closeArea = document.createElement('div');
						closeArea.className = 'mod-modal-closeArea';
						let containerDiv = document.createElement('div');
						containerDiv.appendChild(closeArea);
						containerDiv.appendChild($content.cloneNode(true));

						createModal(containerDiv.innerHTML, e.currentTarget);
					}
					return false;
				});
			});

			// 画像1個だけのモーダル
			document.querySelectorAll('.mod-modalImg').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let appendHTML = `<div class="mod-modal-closeArea"></div>
						<button type="button" class="mod-modal-closeBtn" aria-label="close"><span aria-hidden="true"></span></button>
						${e.currentTarget.querySelector('img').outerHTML}`;
					createModal(appendHTML,e.currentTarget);
					return false;
				});
			});
		},
		matchHeight() {
			const $elements = document.querySelectorAll('[data-mh]');
			const groups = new Map();

			$elements.forEach( ele => { ele.style.height = 'auto'; } ); // 初期化

			$elements.forEach( ele => {
				const attributeName = ele.getAttribute('data-mh');
				if ( !groups.has( attributeName ) ) {
					groups.set( attributeName, [] );
				}
				groups.get( attributeName ).push( ele );
			} );
			groups.forEach( group => {
				const attributeGroups = new Map();
				group.forEach( ele => {
					const attributeName = ele.getAttribute('data-mh');
					const topPosition = ele.getBoundingClientRect().top;
					const key = attributeName + '_' + topPosition;
					if ( !attributeGroups.has( key ) ) {
						attributeGroups.set( key, [] );
					}
					attributeGroups.get( key ).push( ele );
				} );
				attributeGroups.forEach( (item) => {
					const maxHeight = Math.max( ...item.map( ele => ele.offsetHeight ) );
					item.forEach( (ele2) => {
						ele2.style.height = `${maxHeight}px`;
					});
				});
			} );
		},
		inViewAnimation() {
			const fadeTargets = document.querySelectorAll('.js-fade');
			const animTargets = document.querySelectorAll('.js-anim');
			const options = {
				root: null,
				rootMargin: '-30% 0px',
				threshold: 0
			};
			const fadeCallback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(v);
					}
				});
			};
			const animCallback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add('is-active');
					}
				});
			};
			const fadeObserver = new IntersectionObserver(fadeCallback, options);
			const animObserver = new IntersectionObserver(animCallback, options);

			fadeTargets.forEach(ele => {
				fadeObserver.observe(ele);
			});
			animTargets.forEach(ele => {
				animObserver.observe(ele);
			});
		},
		fileSize() {
			const bytesToSize = (bytes) => {
				var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
				if (bytes === 0) {
					return 'n/a';
				}
				var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
				if (i === 0) {
					return bytes + ' ' + sizes[i];
				}
				return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
			}
			if(document.querySelectorAll('.js-fileSize').length) {
				document.querySelectorAll('.js-fileSize').forEach(function (pdfElement) {
					pdfElement.textContent = bytesToSize(pdfElement.textContent);
				});
			}
		},
		removeElmIfEmpty() {
			// ＜ルート設定対応＞要素が空だったら削除
			const $eleList = document.querySelectorAll('.js-checkEmptyElm');
			$eleList.forEach(ele => {
				if (!ele.textContent.length) {
					ele.remove();
				}
			});
		},
		removeBlockIfListEmpty () {
			// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
			const $eleList = document.querySelectorAll('.js-checkEmptyList');
			if ($eleList) {
				$eleList.forEach(ele => {
					if (!ele.getElementsByTagName('li').length) {
						ele.closest('.js-checkEmptyList-wrap').remove();
					}
				});
			}
		},
		URLcurrent() {
			if (document.querySelector('.js-current')) {
				document.querySelectorAll('.js-current').forEach(item1 => {
					// 各要素の href を取得し、現在のページのURLに基づいた絶対パスに変換
					const linkPath = new URL(item1.getAttribute('href'), location.origin).pathname.replace(/index\.html$/, '');
					const currentPath = location.pathname.replace(/index\.html$/, '');
					// 現在のページのパスがリンクのパスで始まる場合、is-activeを追加
					if (currentPath == linkPath) {
						item1.classList.add(a);
					}
				});
			}
		},
		pcHeaderMegamenu(){
			if (document.querySelectorAll('.js-header-nav-mega').length) {
				const $header = document.querySelector('.header');
				const $megabtn = document.querySelectorAll('.js-header-nav-mega-btn');
				const $megamenu = document.querySelectorAll('.js-header-nav-mega-contents');
				
				// アニメーション用関数
				const slideDown = (element) => {
					element.style.display = 'block';
					element.style.height = '0px';
					element.style.overflow = 'hidden';
					
					const targetHeight = element.scrollHeight;
					
					return element.animate(
						{
							height: ['0px', targetHeight + 'px']
						},
						{
							duration: 300,
							easing: 'ease-out',
							fill: 'forwards'
						}
					);
				};
				
				const slideUp = (element) => {
					const currentHeight = element.offsetHeight;
					
					const animation = element.animate(
						{
							height: [currentHeight + 'px', '0px']
						},
						{
							duration: 300,
							easing: 'ease-out',
							fill: 'forwards'
						}
					);
					
					animation.addEventListener('finish', () => {
						element.style.display = 'none';
						element.style.height = '';
						element.style.overflow = '';
						element.classList.remove(a);
					});
					
					return animation;
				};
				
				const closeAllMegaMenus = () => {
					$header.classList.remove(a);
					$megabtn.forEach(btn => {
						btn.classList.remove(a);
						if (btn.nextElementSibling && btn.nextElementSibling.classList.contains(a)) {
							slideUp(btn.nextElementSibling);
						}
					});
				};
				
				// ホバー・フォーカスイベント処理
				$megabtn.forEach(btn => {
					const menu = btn.nextElementSibling;
					let hoverTimeout;
					let focusTimeout;
					
					const openMenu = () => {
						clearTimeout(hoverTimeout);
						clearTimeout(focusTimeout);
						
						// 他のメガメニューを閉じる
						$megabtn.forEach(otherBtn => {
							if (otherBtn !== btn && otherBtn.nextElementSibling && otherBtn.nextElementSibling.classList.contains(a)) {
								otherBtn.classList.remove(a);
								slideUp(otherBtn.nextElementSibling);
							}
						});
						
						// 現在のメニューを開く
						if (menu && !menu.classList.contains(a)) {
							$header.classList.add(a);
							btn.classList.add(a);
							menu.classList.add(a);
							slideDown(menu);
						}
					};
					
					const closeMenuWithDelay = () => {
						hoverTimeout = setTimeout(() => {
							if (menu && menu.classList.contains(a) && !menu.contains(document.activeElement) && document.activeElement !== btn) {
								$header.classList.remove(a);
								btn.classList.remove(a);
								slideUp(menu);
							}
						}, 100);
					};
					
					// ボタンホバー時
					btn.addEventListener('mouseenter', openMenu);
					
					// ボタンフォーカス時
					btn.addEventListener('focus', openMenu);
					
					// ボタンホバーアウト時
					btn.addEventListener('mouseleave', closeMenuWithDelay);
					
					// ボタンブラー時
					btn.addEventListener('blur', () => {
						focusTimeout = setTimeout(() => {
							if (menu && menu.classList.contains(a) && !menu.contains(document.activeElement)) {
								$header.classList.remove(a);
								btn.classList.remove(a);
								slideUp(menu);
							}
						}, 100);
					});
					
					// メニューホバー時
					if (menu) {
						menu.addEventListener('mouseenter', () => {
							clearTimeout(hoverTimeout);
							clearTimeout(focusTimeout);
						});
						
						menu.addEventListener('mouseleave', closeMenuWithDelay);
						
						// メニュー内のフォーカス可能要素にイベントを追加
						const focusableElements = menu.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
						focusableElements.forEach(el => {
							el.addEventListener('focus', () => {
								clearTimeout(hoverTimeout);
								clearTimeout(focusTimeout);
							});
							
							el.addEventListener('blur', () => {
								focusTimeout = setTimeout(() => {
									if (menu && menu.classList.contains(a) && !menu.contains(document.activeElement) && document.activeElement !== btn) {
										$header.classList.remove(a);
										btn.classList.remove(a);
										slideUp(menu);
									}
								}, 100);
							});
						});
					}
				});
				
				// ESCキーでメガメニューを閉じる
				window.addEventListener("keydown", function (event) {
					if ($header.classList.contains(a)) {
						if (event.key === "Escape") {
							event.preventDefault();
							closeAllMegaMenus();
						}
					}
				});
			}
		},
		spHeaderHamburger(){
			if (document.querySelectorAll('.js-header-hamburger').length) {
				const $header = document.querySelector('.header');
				const $hamburger = document.querySelector('.js-header-hamburger');
				const $nav = document.querySelector('.js-header-nav-sp');
				const $container = document.querySelector('.container');
				let scrollTopNow;
				const fixedOnContainer = () => {
					scrollTopNow = window.scrollY;
					$container.style.position = 'fixed';
					$container.style.width = '100%';
					$container.style.top = -1 * scrollTopNow;
					$container.style.left = 0;
					$container.querySelector('.contents').style.opacity = '0';
				};
				const fixedOffContainer = () => {
					$container.style.position = 'static';
					$container.querySelector('.contents').style.opacity = '1';
					window.scrollTo({ top: scrollTopNow });
				};
				const closeMenu = () => {
					$nav.classList.remove(a);
					$hamburger.classList.remove(a);
					$hamburger.ariaLabel = 'open'
					fixedOffContainer();
				};
				
				$hamburger.addEventListener('click', (e) => {
					if ($nav.classList.contains(a)) {
						closeMenu();
					} else {
						fixedOnContainer();
						$nav.classList.add(a);
						$hamburger.classList.add(a);
						$hamburger.ariaLabel = 'close'
					}
				});
				
				// 閉じるボタンのクリックイベント
				const $closeBtn = document.querySelector('.header-nav-sp-inner .__close');
				if ($closeBtn) {
					$closeBtn.addEventListener('click', (e) => {
						closeMenu();
						$hamburger.focus({ preventScroll: true });
					});
				}
				
				window.addEventListener("keydown", function (event) {
					if ($nav.classList.contains(a)) {
						// タブキーが押された時
						if (event.key === "Tab") {
							event.preventDefault();
							// ヘッダー内のフォーカス可能な要素を取得（display: none の要素を除外）
							const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
							let focusableElements = Array.from($header.querySelectorAll(focusableElementsSelector))
								.filter(el => el.offsetParent !== null); // 非表示要素を除外
							if (focusableElements.length === 0) return;
							// 現在のフォーカス位置を取得
							const focusedItemIndex = focusableElements.indexOf(document.activeElement);
							console.log(focusedItemIndex,focusableElements);
							// shiftキーと同時に押されてた場合
							if (event.shiftKey) {
								if (focusedItemIndex === 0) {
									// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
									focusableElements[focusableElements.length - 1].focus();
								} else {
									// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
									focusableElements[focusedItemIndex - 1].focus();
								}
							} else {
								if (focusedItemIndex === focusableElements.length - 1) {
									// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
									focusableElements[0].focus();
								} else {
									// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
									focusableElements[focusedItemIndex + 1].focus();
								}
							}
						}
						// ESCキーが押された時
						if (event.key === "Escape") {
							event.preventDefault();
							closeMenu();
							$hamburger.focus({ preventScroll: true });
						}
					}
				});
			}
		},
		spLinkList() {
			// フッター用（767px以下で動作）
			const $footerAccTtls = document.querySelectorAll('.footer .__spAccCol .__accTtl');
			this.setupAccordionList($footerAccTtls, 767);
			
			// ヘッダー用（1024px以下で動作）
			const $headerAccTtls = document.querySelectorAll('.header .__spAccCol .__accTtl');
			this.setupAccordionList($headerAccTtls, 1024);
		},
		setupAccordionList($accTtls, breakpoint) {
			$accTtls.forEach(ttl => {
				const $innerList = ttl.nextElementSibling;
				
				// クリックイベント
				ttl.addEventListener('click', (e) => {
					// 指定されたブレイクポイント以下で動作
					if (window.innerWidth <= breakpoint) {
						e.preventDefault();
						
						const isOpen = $innerList.style.display === 'block';
						
						if (isOpen) {
							// 閉じる
							ttl.classList.remove(a);
							const currentHeight = $innerList.offsetHeight;
							$innerList.style.height = currentHeight + 'px';
							$innerList.style.overflow = 'hidden';
							
							const closeAnimation = $innerList.animate(
								{
									height: [currentHeight + 'px', '0px']
								},
								{
									duration: 300,
									easing: 'ease-out',
									fill: 'forwards'
								}
							);
							
							closeAnimation.addEventListener('finish', () => {
								$innerList.style.display = 'none';
								$innerList.style.height = '';
								$innerList.style.overflow = '';
							});
						} else {
							// 開く
							ttl.classList.add(a);
							$innerList.style.display = 'block';
							$innerList.style.height = '0px';
							$innerList.style.overflow = 'hidden';
							
							const targetHeight = $innerList.scrollHeight;
							
							const openAnimation = $innerList.animate(
								{
									height: ['0px', targetHeight + 'px']
								},
								{
									duration: 300,
									easing: 'ease-out',
									fill: 'forwards'
								}
							);
							
							openAnimation.addEventListener('finish', () => {
								$innerList.style.height = '';
								$innerList.style.overflow = '';
							});
						}
					}
				});
			});
			
			// リサイズ時にstyle属性をクリア（PC表示時）
			window.addEventListener('resize', () => {
				if (window.innerWidth > breakpoint) {
					$accTtls.forEach(ttl => {
						const $innerList = ttl.nextElementSibling;
						ttl.classList.remove(a);
						$innerList.style.display = '';
						$innerList.style.height = '';
						$innerList.style.overflow = '';
					});
				}
			});
		},
		customSelect() {
			// カスタムセレクトボックスの初期化
			const selectElements = document.querySelectorAll('.js-select, .js-tagSelect');
			
			// ドロップダウンを開く/閉じる関数を先に定義
			const openDropdown = (selectWrapper) => {
				selectWrapper.classList.add('is-open');
				selectWrapper.setAttribute('aria-expanded', 'true');
				const dropdown = selectWrapper.querySelector('.custom-select-dropdown');
				dropdown.style.display = 'block';
				
				// CSSアニメーション用のクラスを追加
				setTimeout(() => {
					dropdown.classList.add('is-opening');
				}, 10);
				
				// 現在の選択項目にフォーカスを設定
				const selectedIndex = selectWrapper.querySelector('select').selectedIndex;
				updateFocusedOption(selectWrapper, selectedIndex);
			};
			
			const closeDropdown = (selectWrapper) => {
				const dropdown = selectWrapper.querySelector('.custom-select-dropdown');
				if (!dropdown) return;
				
				// CSSアニメーション用のクラスを削除
				dropdown.classList.remove('is-opening');
				
				setTimeout(() => {
					selectWrapper.classList.remove('is-open');
					selectWrapper.setAttribute('aria-expanded', 'false');
					dropdown.style.display = 'none';
				}, 200);
				
				// フォーカス状態をクリア
				clearFocusedOption(selectWrapper);
			};
			
			const toggleDropdown = (selectWrapper) => {
				const dropdown = selectWrapper.querySelector('.custom-select-dropdown');
				const isOpen = selectWrapper.classList.contains('is-open');
				
				// 他のすべてのドロップダウンを閉じる
				document.querySelectorAll('.js-select.is-open, .js-tagSelect.is-open').forEach(otherWrapper => {
					if (otherWrapper !== selectWrapper) {
						closeDropdown(otherWrapper);
					}
				});
				
				if (isOpen) {
					closeDropdown(selectWrapper);
				} else {
					openDropdown(selectWrapper);
				}
			};
			
			// 選択されたオプションの表示更新
			const updateSelectedOption = (selectWrapper) => {
				const selectElement = selectWrapper.querySelector('select');
				const selectedOption = selectElement.options[selectElement.selectedIndex];
				const options = selectWrapper.querySelectorAll('.custom-select-option');
				const selectedDisplay = selectWrapper.querySelector('.custom-select-display');
				
				// 選択表示を更新
				if (selectedDisplay) {
					if (selectWrapper.classList.contains('js-tagSelect')) {
						// js-tagSelectの場合：.custom-select-text要素のみを更新
						const selectedTextElement = selectedDisplay.querySelector('.custom-select-text');
						if (selectedTextElement) {
							selectedTextElement.textContent = selectedOption.text;
						}
					} else {
						// js-selectの場合：selectedDisplay全体を更新
						selectedDisplay.textContent = selectedOption.text;
					}
				}
				
				// すべてのオプションから選択状態を削除
				options.forEach(option => option.classList.remove('is-selected'));
				
				// 現在選択されているオプションにクラスを追加
				const selectedCustomOption = selectWrapper.querySelector(`[data-index="${selectElement.selectedIndex}"]`);
				if (selectedCustomOption) {
					selectedCustomOption.classList.add('is-selected');
				}
			};
			
			// フォーカス状態の管理
			const updateFocusedOption = (selectWrapper, focusIndex) => {
				const options = selectWrapper.querySelectorAll('.custom-select-option');
				
				// すべてのオプションからフォーカス状態を削除
				options.forEach(option => option.classList.remove('is-focused'));
				
				// 指定されたインデックスのオプションにフォーカス状態を追加
				if (focusIndex >= 0 && focusIndex < options.length) {
					const focusedOption = options[focusIndex];
					focusedOption.classList.add('is-focused');
					
					// スクロール位置の調整
					const scrollWrapper = selectWrapper.querySelector('.custom-select-scroll-wrapper');
					if (scrollWrapper) {
						const optionTop = focusedOption.offsetTop;
						const optionHeight = focusedOption.offsetHeight;
						const scrollTop = scrollWrapper.scrollTop;
						const scrollHeight = scrollWrapper.offsetHeight;
						
						if (optionTop < scrollTop) {
							scrollWrapper.scrollTop = optionTop;
						} else if (optionTop + optionHeight > scrollTop + scrollHeight) {
							scrollWrapper.scrollTop = optionTop + optionHeight - scrollHeight;
						}
					}
				}
			};
			
			const clearFocusedOption = (selectWrapper) => {
				const options = selectWrapper.querySelectorAll('.custom-select-option');
				options.forEach(option => option.classList.remove('is-focused'));
			};
			
			// 矢印キーでの操作（ドロップダウンが閉じている場合）
			const handleArrowKeysWhenClosed = (selectWrapper, key) => {
				const selectElement = selectWrapper.querySelector('select');
				const currentIndex = selectElement.selectedIndex;
				const optionsLength = selectElement.options.length;
				
				let newIndex = currentIndex;
				
				if (key === 'ArrowDown' && currentIndex < optionsLength - 1) {
					newIndex = currentIndex + 1;
				} else if (key === 'ArrowUp' && currentIndex > 0) {
					newIndex = currentIndex - 1;
				}
				
				if (newIndex !== currentIndex) {
					selectElement.selectedIndex = newIndex;
					const changeEvent = new Event('change', { bubbles: true });
					selectElement.dispatchEvent(changeEvent);
					updateSelectedOption(selectWrapper);
				}
			};
			
			// 矢印キーでの操作（ドロップダウンが開いている場合）
			const handleArrowKeysWhenOpen = (selectWrapper, key) => {
				const selectElement = selectWrapper.querySelector('select');
				const options = selectWrapper.querySelectorAll('.custom-select-option');
				const currentFocused = selectWrapper.querySelector('.custom-select-option.is-focused');
				
				let focusIndex = currentFocused ? 
					parseInt(currentFocused.getAttribute('data-index')) : 
					selectElement.selectedIndex;
				
				if (key === 'ArrowDown' && focusIndex < options.length - 1) {
					focusIndex++;
				} else if (key === 'ArrowUp' && focusIndex > 0) {
					focusIndex--;
				}
				
				updateFocusedOption(selectWrapper, focusIndex);
			};
			
			// Enterキーでの選択確定
			const handleEnterKey = (selectWrapper) => {
				const focusedOption = selectWrapper.querySelector('.custom-select-option.is-focused');
				if (focusedOption) {
					const index = parseInt(focusedOption.getAttribute('data-index'));
					const selectElement = selectWrapper.querySelector('select');
					
					selectElement.selectedIndex = index;
					const changeEvent = new Event('change', { bubbles: true });
					selectElement.dispatchEvent(changeEvent);
					
					updateSelectedOption(selectWrapper);
					closeDropdown(selectWrapper);
				}
			};
			
			selectElements.forEach(selectWrapper => {
				const selectElement = selectWrapper.querySelector('select');
				if (!selectElement) return;
				
				// 既にカスタム化されている場合はスキップ
				if (selectWrapper.querySelector('.custom-select-dropdown')) return;
				
				// カスタムドロップダウンの作成
				const dropdown = document.createElement('div');
				dropdown.className = 'custom-select-dropdown';
				
				// スクロール用のラッパー要素を作成
				const scrollWrapper = document.createElement('div');
				scrollWrapper.className = 'custom-select-scroll-wrapper';
				
				// js-tagSelectの場合は既存のcustom-select-displayを使用、js-selectの場合は新規作成
				let selectedDisplay = selectWrapper.querySelector('.custom-select-display');
				let selectedTextElement;
				
				if (selectWrapper.classList.contains('js-tagSelect')) {
					// js-tagSelectの場合：既存の要素を使用
					if (selectedDisplay) {
						selectedTextElement = selectedDisplay.querySelector('.custom-select-text');
						if (!selectedTextElement) {
							// .custom-select-textが見つからない場合は作成
							selectedTextElement = document.createElement('span');
							selectedTextElement.className = 'custom-select-text';
							selectedDisplay.insertBefore(selectedTextElement, selectedDisplay.firstChild);
						}
					}
				} else {
					// js-selectの場合：新規作成
					selectedDisplay = document.createElement('div');
					selectedDisplay.className = 'custom-select-display';
					selectedTextElement = selectedDisplay; // js-selectの場合はdiv要素自体がテキスト要素
					selectWrapper.appendChild(selectedDisplay);
				}
				
				// 初期テキストを設定
				if (selectedTextElement) {
					selectedTextElement.textContent = selectElement.options[selectElement.selectedIndex].text;
				}
				
				// オプションリストの作成
				const optionsList = document.createElement('ul');
				optionsList.className = 'custom-select-options';
				
				// 各optionをli要素として作成
				Array.from(selectElement.options).forEach((option, index) => {
					const listItem = document.createElement('li');
					listItem.className = 'custom-select-option';
					listItem.textContent = option.text;
					listItem.setAttribute('data-value', option.value);
					listItem.setAttribute('data-index', index);
					
					// デフォルト選択項目の場合
					if (option.value === 'default' || option.selected) {
						listItem.classList.add('is-default');
					}
					
					// オプションクリック時の処理
					listItem.addEventListener('click', (e) => {
						e.stopPropagation();
						
						// 選択されたオプションを元のselectに反映
						selectElement.selectedIndex = index;
						
						// changeイベントを発火
						const changeEvent = new Event('change', { bubbles: true });
						selectElement.dispatchEvent(changeEvent);
						
						// カスタムドロップダウンを閉じる
						closeDropdown(selectWrapper);
						
						// 選択状態の更新
						updateSelectedOption(selectWrapper);
					});
					
					optionsList.appendChild(listItem);
				});
				
				scrollWrapper.appendChild(optionsList);
				dropdown.appendChild(scrollWrapper);
				
				// selectタグの内容更新時にHTMLを再生成する関数を定義
				selectWrapper.rebuildCustomOptions = () => {
					// 既存のオプションリストを削除
					const existingOptionsList = scrollWrapper.querySelector('.custom-select-options');
					if (existingOptionsList) {
						existingOptionsList.remove();
					}
					
					// 新しいオプションリストを作成
					const newOptionsList = document.createElement('ul');
					newOptionsList.className = 'custom-select-options';
					
					// selectElementの現在のoptionを元に再生成
					Array.from(selectElement.options).forEach((option, index) => {
						const listItem = document.createElement('li');
						listItem.className = 'custom-select-option';
						listItem.textContent = option.text;
						listItem.setAttribute('data-value', option.value);
						listItem.setAttribute('data-index', index);
						
						// デフォルト選択項目の場合
						if (option.value === 'default' || option.selected) {
							listItem.classList.add('is-default');
						}
						
						// オプションクリック時の処理
						listItem.addEventListener('click', (e) => {
							e.stopPropagation();
							
							// 選択されたオプションを元のselectに反映
							selectElement.selectedIndex = index;
							
							// changeイベントを発火
							const changeEvent = new Event('change', { bubbles: true });
							selectElement.dispatchEvent(changeEvent);
							
							// カスタムドロップダウンを閉じる
							closeDropdown(selectWrapper);
							
							// 選択状態の更新
							updateSelectedOption(selectWrapper);
						});
						
						newOptionsList.appendChild(listItem);
					});
					
					scrollWrapper.appendChild(newOptionsList);
					
					// 選択表示も更新
					if (selectedTextElement) {
						selectedTextElement.textContent = selectElement.options[selectElement.selectedIndex].text;
					}
				};
				
				// js-selectの場合のみselectedDisplayを追加（js-tagSelectは既にHTMLに存在）
				if (!selectWrapper.classList.contains('js-tagSelect')) {
					selectWrapper.appendChild(selectedDisplay);
				}
				selectWrapper.appendChild(dropdown);
				
				// 元のselectタグをフォーカス不可能にする
				selectElement.setAttribute('tabindex', '-1');
				selectElement.setAttribute('aria-hidden', 'true');
				
				// ラベル要素のクリックイベント
				selectWrapper.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopPropagation();
					toggleDropdown(selectWrapper);
				});
				
				// selectWrapper要素をフォーカス可能にする
				selectWrapper.setAttribute('tabindex', '0');
				selectWrapper.setAttribute('role', 'combobox');
				selectWrapper.setAttribute('aria-expanded', 'false');
				selectWrapper.setAttribute('aria-haspopup', 'listbox');
				
				// アクセシビリティ用のlabel関連付け
				const labelElement = selectWrapper.querySelector('label');
				if (labelElement && labelElement.getAttribute('for')) {
					const labelText = labelElement.textContent || 'select';
					selectWrapper.setAttribute('aria-label', labelText);
				}
				
				// キーボードイベント
				selectWrapper.addEventListener('keydown', (e) => {
					const isOpen = selectWrapper.classList.contains('is-open');
					
					if (e.key === 'Enter') {
						e.preventDefault();
						if (isOpen) {
							handleEnterKey(selectWrapper);
						} else {
							toggleDropdown(selectWrapper);
						}
					} else if (e.key === ' ') {
						e.preventDefault();
						if (!isOpen) {
							openDropdown(selectWrapper);
						}
					} else if (e.key === 'Escape') {
						e.preventDefault();
						if (isOpen) {
							closeDropdown(selectWrapper);
						}
					} else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
						e.preventDefault();
						if (isOpen) {
							handleArrowKeysWhenOpen(selectWrapper, e.key);
						} else {
							handleArrowKeysWhenClosed(selectWrapper, e.key);
						}
					} else if (e.key === 'Tab') {
						// Tabキーの場合は自然な動作を許可し、ドロップダウンが開いていれば閉じる
						if (isOpen) {
							closeDropdown(selectWrapper);
						}
					}
				});
				
				// 初期選択状態の設定
				updateSelectedOption(selectWrapper);
			});
			
			// 外部クリックでドロップダウンを閉じる
			document.addEventListener('click', (e) => {
				if (!e.target.closest('.js-select') && !e.target.closest('.js-tagSelect')) {
					document.querySelectorAll('.js-select.is-open, .js-tagSelect.is-open').forEach(selectWrapper => {
						closeDropdown(selectWrapper);
					});
				}
			});
		},
		loadDelayScript() {
			let _this = this;
			_this.accordion();
			_this.accBtn();
			_this.carousel();
			_this.mainVisSwiper();
			_this.dateFormat();
			_this.formatKeyword();
			_this.createSelect();
			_this.shopSearch();
			_this.mapCreate();
			_this.tabSwitch();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.setModal();
			_this.matchHeight();
			_this.inViewAnimation();
			_this.fileSize();
			_this.removeElmIfEmpty();
			_this.removeBlockIfListEmpty();
			_this.URLcurrent();
			_this.pcHeaderMegamenu();
			_this.spHeaderHamburger();
			_this.spLinkList();
			
			// .js_shopSearchが存在しない場合のみcustomSelect()を実行
			// （存在する場合はcreateSelect()内で実行される）
			if (!document.querySelector('.js_shopSearch')) {
				_this.customSelect();
			}

			let resizeTime = 0;
			window.addEventListener('resize', () => {
				clearTimeout(resizeTime);
				resizeTime = setTimeout(() => { _this.matchHeight(); }, 300);
			});
		}
	};

	document.addEventListener('DOMContentLoaded', () => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})();
